import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import { BreadCrumb, Card, Modal } from '../../components';
import { Translate } from '../../contexts/Language';
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import { ErrorMessage } from '../../components/Validator';


export class CustomerDocuments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataTable: {
        columns: DataTableColumns.documentList,
        rows: [],
      },
      modal: false,
      customerLogin: 0,
      detail: {
        files: [],
        file: null,
      },
      validation: {
        error: false,
        message: '',
      },
    };

    this.onDetail = this.onDetail.bind(this);
  }

  componentDidMount() {
    this.onDatatable();
  }

  onDatatable() {
    Config.utilities.loadingFetch();

    Service.DocumentService.List().then(response => {
      if (response) {
        const { dataTable } = this.state;

        dataTable.rows = response;

        this.setState({
          dataTable,
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  onDetail(login) {
    Config.utilities.loadingFetch();

    Service.DocumentService.Detail({ login }).then(response => {
      if (response) {
        this.setState({
          detail: response,
          modal: true,
          customerLogin: login,
        });
      }
      Config.utilities.loadingFetch();
    });
  }

  onAction(status) {
    Config.utilities.loadingFetch();

    const { customerLogin } = this.state;

    Service.DocumentService.Action({ login: customerLogin, approve: status }).then(response => {
      if (response) {
        if (response.error) {
          this.setState({
            validation: response,
          });
        } else {
          this.setState({
            modal: false,
            customerLogin: 0,
          });
          this.onDatatable();
        }
      }
      Config.utilities.loadingFetch();
    });
  }

  render() {
    const { modal, validation, detail, dataTable } = this.state;
    return (
      <>
        <BreadCrumb Title={Translate('Customer Documents')} Name={Translate('Customer Documents')} />
        <Card Title="Customer Documents" Description="Customer uploaded images.">
          <Modal Title={Translate('Customer Images')} Show={modal} onClose={() => this.setState({ modal: false })}>
            <div className="row mt-1 mb-1">
              <div className="col-md-12">
                <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                  <ErrorMessage Validation={validation} />
                  <div className="row">
                    {detail.files.map((item, index) => (
                      <div className="col-md-6 img-wrapper mt-4" key={index}>
                        <img className="img-fluid customer-document" src={`data:${item.image.contentType};base64,${item.image.fileContents}`} alt="" />
                      </div>
                    ))}
                  </div>

                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="save-form" className="col-sm-4 col-form-label" />
                    <div className="col-sm-8">
                      <button type="button" className="btn btn-danger float-right" onClick={() => this.onAction(false)}>
                        <i className="far fa-save mr-2" />
                        <span>Reject</span>
                      </button>
                      <button type="button" className="btn btn-success float-right mr-2" onClick={() => this.onAction(true)}>
                        <i className="far fa-save mr-2" />
                        <span>Approve</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
          <div className="row">
            <div className="col-md-12">
              {dataTable.rows.length === 0 ? (
                <div className="alert alert-light" role="alert">
                  <em>
                    <strong className="mr-2">No record!</strong>
                    {Translate('No records found for the filter.')}
                  </em>
                </div>
              ) :
                (
                  <DataTable
                    noHeader
                    columns={dataTable.columns(this.onDetail)}
                    data={dataTable.rows}
                    pagination
                    highlightOnHover
                  />
                )}
            </div>
          </div>
        </Card>
      </>
    );
  }
}
